export class KeiyakushaFindConditionViewModel {
    /** 契約者コード */
    userCd = null;
    /** 契約者名 */
    userName = "";
    /** 契約区分 */
    userKb = null;
    /** 物件コード */
    buknCd = null;
    /** 物件名 */
    buknName = "";
    /** 検索ボタン押下フラグ */
    isSearch = false;
    clear() {
        this.userCd = null;
        this.userName = "";
        this.userKb = null;
        this.buknCd = null;
        this.buknName = "";
        this.isSearch = false;
    }
    copyFrom(condition) {
        this.userCd = condition.userCd;
        this.userName = condition.userName;
        this.userKb = condition.userKb;
        this.buknCd = condition.buknCd;
        this.buknName = condition.buknName;
        this.isSearch = condition.isSearch;
    }
    get summary() {
        let txt = "";
        const getDelimiter = function (text) {
            return text.length === 0 ? "" : "、 ";
        };
        if (this.userCd) {
            txt += getDelimiter(txt);
            txt += ` 契約者コード:${this.userCd}`;
        }
        if (this.userName) {
            txt += getDelimiter(txt);
            txt += `契約者名:${this.userName}`;
        }
        if (this.userKb) {
            txt += getDelimiter(txt);
            txt += `契約区分:${this.userKb.label}`;
        }
        if (this.buknCd) {
            txt += getDelimiter(txt);
            txt += `物件コード:${this.buknCd}`;
        }
        if (this.buknName) {
            txt += getDelimiter(txt);
            txt += `物件名:${this.buknName}`;
        }
        return txt === "" ? "検索条件" : txt;
    }
}
